import React from 'react';
import PropTypes from 'prop-types';

export const Check = ({ width, height, ...props }) => (
  <svg
    data-icon='check'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m9.552 18-5.7-5.7 1.425-1.425 4.275 4.275 9.175-9.175L20.152 7.4 9.552 18Z'
    />
  </svg>
);

Check.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Check.defaultProps = {
  width: 24,
  height: 24,
};
